export const namespaced = true;

/* ===========================
   Cookie helpers
=========================== */
const COOKIE_KEY = 'mc';

function writeCookie(key, value) {
  const currentDomain = window.location.hostname;
  const cookieDomain = currentDomain.startsWith('www.')
    ? currentDomain.substring(4)
    : currentDomain;

  const expiryDays = 365;
  const expiryDate = new Date(Date.now() + expiryDays * 24 * 60 * 60 * 1000);

  document.cookie =
    key + '=' + encodeURIComponent(value) + '; ' +
    'expires=' + expiryDate.toUTCString() + '; ' +
    'path=/; ' +
    'domain=' + cookieDomain + ';';
}

function readCookie(key) {
  const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function clearCookie(key) {
  const currentDomain = window.location.hostname;
  document.cookie = key + '=; Max-Age=0; domain=' + currentDomain + '; path=/';
}

/* ===========================
   State
=========================== */
export const state = () => ({
  menuCampaignId: null,
  customerName: null,
  customerLogo: null,
  menuName: null,
  menuCode: null,
  urlCode: null,
  isMenuCampaignWithOrder: null,
  isCollectingData: null,
  isWithGift: null
});

/* ===========================
   Mutations
=========================== */
export const mutations = {
  SET_MENU_CAMPAIGN_STATE(state, payload) {
    state.menuCampaignId = payload.menuCampaignId;
    state.customerName = payload.customerName;
    state.customerLogo = payload.customerLogo;
    state.menuName = payload.menuName;
    state.menuCode = payload.menuCode;
    state.urlCode = payload.urlCode;
    state.isMenuCampaignWithOrder = payload.isMenuCampaignWithOrder;
    state.isCollectingData = payload.isCollectingData;
    state.isWithGift = payload.isWithGift;

    // Persist to cookie
    writeCookie(COOKIE_KEY, JSON.stringify(payload));
  },

  RESET_MENU_CAMPAIGN(state) {
    state.menuCampaignId = null;
    state.customerName = null;
    state.customerLogo = null;
    state.menuName = null;
    state.menuCode = null;
    state.urlCode = null;
    state.isMenuCampaignWithOrder = null,
    state.isCollectingData = null,
    state.isWithGift = null

    clearCookie(COOKIE_KEY);
  },
};

/* ===========================
   Actions
=========================== */
export const actions = {



  setStateFromCampaign({ commit }, campaign) {
    if (!campaign) return;

    commit('SET_MENU_CAMPAIGN_STATE', {
      menuCampaignId: campaign.id,
      customerName: campaign.customerName || campaign.customer?.companyName || null,
      customerLogo: campaign.bagsModel || null,
      menuName: campaign.name,
      menuCode: campaign.menuCode,
      urlCode: campaign.urlCode,
      isMenuCampaignWithOrder: campaign.isMenuCampaignWithOrder,
      isCollectingData: campaign.isCollectingData,
      isWithGift: campaign.isWithGift,
    });
  },

  setMenuCampaignData({ commit }, payload) {
    commit('SET_MENU_CAMPAIGN_STATE', payload);
  },

  resetMenuCampaign({ commit }) {
    commit('RESET_MENU_CAMPAIGN');
  },

  // Restore Vuex state from cookie (call on app init)
  restoreFromCookie({ commit }) {
    const saved = readCookie(COOKIE_KEY);
    if (saved) {
      commit('SET_MENU_CAMPAIGN_STATE', JSON.parse(saved));
    }
  },

};

/* ===========================
   Getters
=========================== */
export const getters = {
  menuCampaignId: (state) => state.menuCampaignId,
  customerName: (state) => state.customerName,
  customerLogo: (state) => state.customerLogo,
  menuName: (state) => state.menuName,
  menuCode: (state) => state.menuCode,
  urlCode: (state) => state.urlCode,

  featureFlags: s => ({
    menuCampaignWithOrder: s.isMenuCampaignWithOrder,
    withGift: s.isWithGift,
    collectingData: s.isCollectingData,
  }),

  hasMenuCampaignId: (state) => !!state.menuCampaignId,

  menuCampaign: (state) => ({
    menuCampaignId: state.menuCampaignId,
    customerName: state.customerName,
    customerLogo: state.customerLogo,
    menuName: state.menuName,
    urlCode: state.urlCode
  }),
};
